/* eslint-disable no-restricted-syntax */
/* eslint-disable no-cond-assign */
import classNames from 'classnames';

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import * as ProposalNS from '../../Proposal';
import { FIXED_INCOME_DURATION_CATEGORIES, FIXED_INCOME_CREDIT_RATING_CATEGORIES } from '../../../../utils/constants';

import * as ProposalElementNS from '../../ProposalElements';

import { DataPoints, DataPointResponse } from '../DataPoints';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import { NotApplicableCell, PercentageCell } from '../../../../views/components/cells';
import LocalizedString from '@/types/localized-string';

export default class FixedIncomeStyleDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new FixedIncomeStyleDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return ['STYLE_COLORS'];
  }

  protected build(): void {
    let itemDAO = null;
    while ((itemDAO = this.nextItem()) !== null) {
      const itemDurationClassKeys: LocalizedString[] = DataPoints.getDurationClassKeys(itemDAO.item);
      const itemCreditRatingClassKeys: LocalizedString[] = DataPoints.getCreditRatingClassKeys(itemDAO.item);

      this.addFieldDAO(itemDAO, new ProposalFieldDAO('', ''));
      this.addFieldName(
        this.formatMessage('Proposal.Modules.FixedIncomeStyle.Categories.Term'),
        classNames(ProposalStyleClassNames.ProposalTableGroup, ProposalStyleClassNames.ProposalTableContent),
      );
      const fieldClasses = classNames(ProposalStyleClassNames.ProposalTableContent, ProposalStyleClassNames.ProposalTableIndentField);

      for (const durationKey in FIXED_INCOME_DURATION_CATEGORIES) {
        if (Object.prototype.hasOwnProperty.call(FIXED_INCOME_DURATION_CATEGORIES, durationKey)) {
          const durationStr: string = FIXED_INCOME_DURATION_CATEGORIES[durationKey as keyof typeof FIXED_INCOME_DURATION_CATEGORIES];

          const itemDurationClass: LocalizedString | undefined = itemDurationClassKeys.find(
            itemDurationClassKey => itemDurationClassKey['en-CA'] === durationStr,
          );

          let value: number | undefined;
          if (itemDurationClass !== undefined && itemDurationClass['en-CA'] !== undefined) {
            const dpResponse: DataPointResponse<number> = DataPoints.getDurationClassByKey(itemDAO.item, itemDurationClass['en-CA']);
            value = dpResponse.response;
            this.addDisclaimerKeys(dpResponse.disclaimerKeys, itemDAO.item);
          }

          const fieldName: string = this.formatMessage(`FixedIncomeDuration.${durationStr}`);
          const field = new ProposalFieldDAO(fieldName, value != null ? value : undefined, ProposalStyleClassNames.ProposalTableContent);
          field.cellType = value === undefined ? NotApplicableCell : PercentageCell;
          field.key = durationKey;
          this.addFieldDAO(itemDAO, field);
          this.addFieldName(fieldName, fieldClasses, undefined);
        }
      }

      this.addFieldDAO(itemDAO, new ProposalFieldDAO('', ''));
      this.addFieldName(
        this.formatMessage('Proposal.Modules.FixedIncomeStyle.Categories.CreditRating'),
        classNames(ProposalStyleClassNames.ProposalTableGroup, ProposalStyleClassNames.ProposalTableContent),
      );

      for (const creditRatingKey in FIXED_INCOME_CREDIT_RATING_CATEGORIES) {
        if (Object.prototype.hasOwnProperty.call(FIXED_INCOME_CREDIT_RATING_CATEGORIES, creditRatingKey)) {
          const creditRatingStr: string = FIXED_INCOME_CREDIT_RATING_CATEGORIES[creditRatingKey as keyof typeof FIXED_INCOME_CREDIT_RATING_CATEGORIES];

          const itemCreditRatingClass: LocalizedString | undefined = itemCreditRatingClassKeys.find(
            itemCreditRatingClassKey => itemCreditRatingClassKey['en-CA'] === creditRatingStr,
          );

          let value: number | undefined;
          if (itemCreditRatingClass !== undefined && itemCreditRatingClass['en-CA'] !== undefined) {
            const dpResponse: DataPointResponse<number> = DataPoints.getCreditRatingClassByKey(itemDAO.item, itemCreditRatingClass['en-CA']);
            value = dpResponse.response;
            this.addDisclaimerKeys(dpResponse.disclaimerKeys, itemDAO.item);
          }

          const fieldName: string = this.formatMessage(`FixedIncomeCreditRating.${creditRatingStr}`);
          const field = new ProposalFieldDAO(fieldName, value != null ? value : undefined, ProposalStyleClassNames.ProposalTableContent);
          field.cellType = value === undefined ? NotApplicableCell : PercentageCell;
          field.key = creditRatingKey;
          this.addFieldDAO(itemDAO, field);
          this.addFieldName(fieldName, fieldClasses, undefined);
        }
      }
    }
  }
}
